import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useIncomeHistoryHelpers } from "@Client/@Composables/application-standalone/pages/income-history/useIncomeHistoryHelpers";
import { useAdditionalIncomeHelpers } from "@Client/@Composables/application-standalone/pages/additional-income/useAdditionalIncomeHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import { orderBy } from "lodash";
import { ordinalIndex } from "@Shared/@Utils/helpers/text";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
import { APPLICANT_OCCUPATION, APPLICANT_INDUSTRY_SECTOR, APPLICANT_INCOME_TYPE, APPLICANT_EMPLOYMENT_TYPE, APPLICANT_INCOME_PERIOD, APPLICANT_OPERATING_AS } from "@Shared/@Types/application/application-enums";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
export default defineComponent({
  name: "IncomeHistorySummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidIncomes = ref([]);
    const invalidAdditionalIncomes = ref([]);
    const {
      t
    } = useI18n();
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      getTextForAddButton,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      employmentSummarySubtitle,
      applicantHasEmployment
    } = useIncomeHistoryHelpers();
    const {
      UPDATE_IS_RETIRED_FIELD
    } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.UPDATE_IS_RETIRED_FIELD]);
    const {
      addEmptyIncomeHistory,
      deleteIncomeHistory,
      addRetiredEmploymentHistory
    } = useIncomeHistoryHelpers();
    const {
      getInvalidIncomes,
      getInvalidAdditionalIncomes,
      atLeastOneIncomePerApplicant
    } = useValidatorsHelper();
    onMounted(() => {
      if (!allApplicants.value.some(applicant => applicant["personal-details"]["is-retired"])) updateInvalidIncomes();
      updateInvalidAdditionalIncomes();
    });
    const updateInvalidIncomes = async () => {
      invalidIncomes.value = await getInvalidIncomes();
    };
    const updateInvalidAdditionalIncomes = async () => {
      invalidAdditionalIncomes.value = await getInvalidAdditionalIncomes();
    };
    const areInvalidIncomesOrAdditionalIncomes = computed(() => !atLeastOneIncomePerApplicant() || !!invalidIncomes.value.length || !!invalidAdditionalIncomes.value.length);
    watch(areInvalidIncomesOrAdditionalIncomes, newValue => {
      emit("disable-save", newValue);
    }, {
      immediate: true
    });
    const {
      addEmptyAdditionalIncome,
      deleteAdditionalIncome,
      applicantHasAdditionalIncome,
      additionalIncomeSummarySubtitle,
      additionalIncomeVisibleMainApplicant,
      additionalIncomeVisibleCoApplicants
    } = useAdditionalIncomeHelpers();
    const additionalIncomeVisibleByApplicant = applicantIndex => {
      return applicantIndex === 0 ? additionalIncomeVisibleMainApplicant.value : additionalIncomeVisibleCoApplicants.value;
    };
    const handleAddIncomeSource = (applicantIndex, applicantId) => {
      addEmptyIncomeHistory(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (applicant) {
        handleNavigation(applicantIndex, applicant.employment.length - 1, applicantId);
      }
    };
    const handleAddAdditionalIncome = (applicantIndex, applicantId) => {
      addEmptyAdditionalIncome(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (applicant) {
        handleNavigation(applicantIndex, applicant["other-income"].length - 1, applicantId, true);
      }
    };
    const handleNavigation = (applicantIndex, incomeIndex, applicantId = "", additionalIncome = false) => {
      emit("navigate", {
        applicantIndex,
        incomeIndex,
        applicantId,
        additionalIncome
      });
    };
    const addIncomeButtonText = applicant => {
      return getTextForAddButton("application-standalone.pages.incomeHistory.addIncomeSource", {
        iteratee: applicantHasEmployment,
        singleValue: applicant["employment"]
      });
    };
    const isIncomeInvalid = (appIndex, employmentIndex) => {
      return invalidIncomes.value.some(({
        applicantIndex,
        incomeIndex
      }) => applicantIndex === appIndex && incomeIndex === employmentIndex);
    };
    const isAdditionalIncomeInvalid = (appIndex, employmentIndex) => {
      return invalidAdditionalIncomes.value.some(({
        applicantIndex,
        incomeIndex
      }) => applicantIndex === appIndex && incomeIndex === employmentIndex);
    };
    const firstIncomeError = computed(() => {
      var _errorOrdered$;
      const errorOrdered = orderBy([...invalidIncomes.value, ...invalidAdditionalIncomes.value], ["applicantIndex", "incomeIndex"]);
      return (_errorOrdered$ = errorOrdered[0]) != null ? _errorOrdered$ : null;
    });
    const isFirstError = (appIndex, employmentIndex, isAdditionalIncome = false) => {
      if (!firstIncomeError.value) return false;
      const {
        applicantIndex,
        incomeIndex,
        address
      } = firstIncomeError.value;
      const isAdditionalEmployment = !address;
      return applicantIndex === appIndex && employmentIndex === incomeIndex && isAdditionalIncome === isAdditionalEmployment;
    };
    const firstAdditionalIncomeError = computed(() => {
      var _invalidAdditionalInc, _invalidAdditionalInc2;
      return (_invalidAdditionalInc = (_invalidAdditionalInc2 = invalidAdditionalIncomes.value) == null ? void 0 : _invalidAdditionalInc2[0]) != null ? _invalidAdditionalInc : null;
    });
    const isAdditional = ref(false);
    const handleDelete = ({
      applicantIndex,
      employmentIndex,
      otherIncomeIndex
    }) => {
      if (!isAdditional.value) handleDeleteIncome({
        applicantIndex,
        employmentIndex
      });else handleDeleteAdditionalIncome({
        applicantIndex,
        otherIncomeIndex
      });
    };
    const handleDeleteIncome = ({
      applicantIndex,
      employmentIndex
    }) => {
      var _allApplicants$value$, _context;
      deleteIncomeHistory(applicantIndex, employmentIndex);
      if ((_allApplicants$value$ = _findInstanceProperty(_context = allApplicants.value).call(_context, (_, index) => index === applicantIndex)) != null && _allApplicants$value$["personal-details"]["is-retired"]) updateInvalidIncomes();
    };
    const handleDeleteAdditionalIncome = ({
      applicantIndex,
      otherIncomeIndex
    }) => {
      deleteAdditionalIncome(applicantIndex, otherIncomeIndex);
      updateInvalidAdditionalIncomes();
      isAdditional.value = false;
    };
    const modalText = computed(() => {
      return !isAdditional.value ? t("application-form.removeComponentModalMessage", {
        componentType: "income"
      }) : t("application-form.removeComponentModalMessage", {
        componentType: "additional income"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = (data, additionalIncome = false) => {
      var _removeComponentModal;
      isAdditional.value = additionalIncome;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    const setApplicantAsRetired = (applicant, applicantIndex) => {
      const employerDetails = allApplicants.value[applicantIndex]["personal-details"];
      const isRetired = allApplicants.value[applicantIndex]["personal-details"]["is-retired"];
      if (isRetired) {
        var _context2, _context3;
        const employmentIndex = _findIndexInstanceProperty(_context2 = allApplicants.value[applicantIndex]["employment"]).call(_context2, employment => employment["employer-name"] === "Retired/Homemaker");
        allApplicants.value[applicantIndex]["employment"] = _filterInstanceProperty(_context3 = allApplicants.value[applicantIndex]["employment"]).call(_context3, employment => employment["employer-name"] !== "Retired/Homemaker");
        deleteIncomeHistory(applicantIndex, employmentIndex);
        updateInvalidIncomes();
      } else {
        let retiredEmployment = {
          "current-job": true,
          "employer-name": "Retired/Homemaker",
          "work-phone": employerDetails["phone-number"],
          "job-title": "Retired/Homemaker",
          "company-type": "",
          "employment-type": APPLICANT_EMPLOYMENT_TYPE.FULL_TIME,
          "self-employed": false,
          "operating-as": APPLICANT_OPERATING_AS.CORPORATION,
          "gross-revenue": "0",
          occupation: APPLICANT_OCCUPATION.RETIRED,
          "industry-sector": APPLICANT_INDUSTRY_SECTOR.OTHER,
          "income-type": APPLICANT_INCOME_TYPE.OTHER_EMPLOYMENT_INCOME,
          "income-period": APPLICANT_INCOME_PERIOD.ANNUAL,
          "income-amount": "0",
          address: employerDetails["addresses"] && employerDetails["addresses"][0] ? employerDetails["addresses"][0] : {
            line1: "",
            line2: "",
            city: "",
            province: "",
            "postal-code": "",
            "street-direction": "",
            "street-type": "",
            "street-name": "",
            "street-number": "",
            "unit-number": "",
            "time-at": 0
          },
          "time-at-job": "13",
          "months-in-industry": "13"
        };
        addRetiredEmploymentHistory(applicantIndex);
        allApplicants.value[applicantIndex]["employment"][0] = retiredEmployment;
      }
      UPDATE_IS_RETIRED_FIELD({
        applicantIndex,
        value: !isRetired
      });
    };
    return {
      handleDeleteAdditionalIncome,
      handleDeleteIncome,
      handleDelete,
      handleAddIncomeSource,
      handleAddAdditionalIncome,
      allApplicants,
      applicantNameFromIndex,
      handleNavigation,
      deleteIncomeHistory,
      employmentSummarySubtitle,
      applicantHasEmployment,
      addEmptyAdditionalIncome,
      deleteAdditionalIncome,
      additionalIncomeSummarySubtitle,
      applicantHasAdditionalIncome,
      additionalIncomeVisibleMainApplicant,
      additionalIncomeVisibleCoApplicants,
      additionalIncomeVisibleByApplicant,
      addIncomeButtonText,
      isApplicantVisibleFromFillOut,
      isAdditionalIncomeInvalid,
      isIncomeInvalid,
      invalidIncomes,
      invalidAdditionalIncomes,
      editButtonText,
      allowEdit,
      firstIncomeError,
      firstAdditionalIncomeError,
      isFirstError,
      ordinalIndex,
      areInvalidIncomesOrAdditionalIncomes,
      modalText,
      removeComponentModal,
      openDeletionModal,
      setApplicantAsRetired
    };
  }
});